import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import HeroNews from '../../../components/HeroNews';
import LatestAndTopNews from '../../../components/LatestAndTopNews';
import PickCategoryByPageId from '../../../models/PickCategoryByPageId';
import TimestampToDate from '../../../models/TimestampToDate';
import Iopt from '../../../utils/Iopt';
import BoxNewsCategory from '../components/BoxNewsCategory';

function CategorySection01Md({ category, pageId, articles, latestArticles = [] }) {
    const cat = PickCategoryByPageId(category, pageId);
    const [moreCount, setMoreCount] = useState(15);

    const handleMoreCount = () => {
        setMoreCount(moreCount + 10);
    };

    const totalCat = articles.length;
    // bangladesh
    // international
    // expatriation
    // technology
    // lifestyle
    // health
    let tBg = 'home-category-news-title';
    if (
        pageId === 'bangladesh' ||
        pageId === 'international' ||
        pageId === 'expatriation' ||
        pageId === 'technology' ||
        pageId === 'lifestyle' ||
        pageId === 'health' ||
        pageId === 'education'
    ) {
        tBg = 'home-category-news-title-green';
    }
    return (
        <div className="col col-840">
            <div className="row">
                <div className="col-12">
                    <div className={tBg}>
                        <div className="home-category-news-title-sub">
                            <Link to={cat.url}>{cat.title}</Link>
                        </div>
                    </div>
                </div>

                <div className="col-6">
                    <HeroNews article={articles[0]} />
                </div>

                <div className="col-6">
                    <LatestAndTopNews latestArticles={latestArticles} maxArticle={5} />
                </div>

                <div className="col-6">
                    <BoxNewsCategory article={articles[3]} />
                </div>
                <div className="col-6">
                    <BoxNewsCategory article={articles[4]} />
                </div>
                <div className="col-6">
                    <BoxNewsCategory article={articles[5]} />
                </div>

                <div className="col-6">
                    <BoxNewsCategory article={articles[6]} />
                </div>
                <div className="col-6">
                    <BoxNewsCategory article={articles[7]} />
                </div>
                <div className="col-6">
                    <BoxNewsCategory article={articles[8]} />
                </div>

                {Object.values(articles)
                    .slice(9, moreCount)
                    ?.map((rows) => (
                        <div className="col-12" key={rows.sl}>
                            <Link to={rows.link} className="category-news link-area">
                                <div className="category-news-img align-self-center">
                                    <img src={Iopt(rows.image, 360)} alt="news" />
                                </div>
                                <div className="category-news-title link-title align-self-center">
                                    <h4 className="link-title">{rows.title}</h4>
                                    <h5>{rows.summery}</h5>
                                    <p className="category-news-f-time float-right">
                                        <TimestampToDate time={rows.time_published} />
                                    </p>
                                </div>
                            </Link>
                        </div>
                    ))}
                <div className="col-12">
                    <div className="category-news-more-btn">
                        <Button onClick={handleMoreCount}>
                            {totalCat <= moreCount ? 'শেষ ' : 'আরও'}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CategorySection01Md;
